module.exports = __webpack_public_path__ + "assets/CenterOfRotation.d4f05800a6c43be77cc7484efc136c87.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/CenterOfRotation.gmt
// module id = 910
// module chunks = 0